import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ClientUserData } from "@/common/types/client/user.type";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useClientUsers } from "@/features/users/hooks/useClientUsers";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterBuyerBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: usersOptions,
  } = useClientUsers({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ClientUserData>({
      labelFieldName: 'full_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.Buyer}
      options={usersOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterBuyerBadge;
